// extracted by mini-css-extract-plugin
export default {"starWrapper":"StarRating_starWrapper__icZWu","star":"StarRating_star__KrUaB","activeStar":"StarRating_activeStar__2lK0L"};